interface Param {
  index: number;
  key: string;
  name: string;
  polyline: string;
}

export class SearchArea {
  readonly index: number;
  readonly key: string;
  readonly name: string;
  readonly polyline: string;

  constructor(params: Param) {
    this.index = params.index;
    this.key = params.key;
    this.name = params.name;
    this.polyline = params.polyline;
  }

  eq(other: SearchArea | null): boolean {
    if (other === null) {
      return false;
    }
    return this.key === other.key;
  }
}
